import { Toast } from "@newsela/angelou";

export const EVENT_TOAST_SUCCESS_JOIN_CLASS = {
  showIcon: true,
  statusColor: Toast.statusColor.success,
  children: "Successfully joined the class",
};

export const EVENT_TOAST_ERROR_JOIN_CLASS = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Failed to join the class",
};

export const EVENT_TOAST_FAILED_CLASS_ERROR = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Could not find the class",
};

export const EVENT_TOAST_FAILED_CLASS_ARCHIVED = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "The class is archived",
};
